import React from 'react';
import { motion } from 'framer-motion';

import { AppWrap } from '../../wrapper';
import { images } from '../../constants';
import resume from '../../assets/BlockChain Developer__kyilax.pdf'

import './Header.scss';

const scaleVariants = {
    whileInView: {
        scale: [0, 1],
        opacity: [0, 1],
        transition: {
            duration: 1,
            ease: 'easeInOut',
        },
    },
};

const Header = () => (
    <div className="app__header app__flex">
        <motion.div
            whileInView={{ x: [-100, 0], opacity: [0, 1] }}
            transition={{ duration: 0.5 }}
            className="app__header-info"
        >
            <div className="app__header-badge">
                <div className="badge-cmp app__flex" style={{ paddingLeft: "50px" }}>
                    <span style={{ fontSize: "2rem" }}>👋</span>
                    <div style={{ paddingLeft: "50px" }}>
                        <p className="p-text" >Hello, I am</p>
                        <h1 className="head-text" style={{ fontSize: "3rem" }}>Daniel</h1>
                    </div>
                </div>

                <div className="tag-cmp app__flex" >
                    <p className="p-text" style={{ fontSize: "1.1rem" }}>BLOCKCHAIN DEVELOPER</p>
                    <p className="p-text" style={{ fontSize: "1.1rem" }}>REACT JS DEVELOPER</p>

                </div>

                <div className="abt">
                    <a download="BlockChain_Developer_Kyilax" target={"_blank"} style={{ textDecoration: "none", color: "black" }} href={resume}>
                        <p className="cv" style={{ fontSize: "1.1rem" }}>
                            Download CV
                        </p>
                    </a>

                    <a href="/#contact" style={{ textDecoration: "none", color: "black" }}><p className="talk" style={{ fontSize: "1.1rem" }}>Let's Talk </p></a>
                </div>
            </div>
        </motion.div>

        <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, delayChildren: 0.5 }}
            className="app__header-img"
        >
            {/* <img src={images.circle} alt="profile_bg" /> */}
            <motion.img
                whileInView={{ scale: [0, 1] }}
                transition={{ duration: 1, ease: 'easeInOut' }}
                src={images.circle}
                alt="profile_circle"
                className="overlay_circle"
            />
        </motion.div>

        <motion.div
            variants={scaleVariants}
            whileInView={scaleVariants.whileInView}
            className="app__header-circles"
        >
            {[images.javascript, images.solidity, images.react].map((circle, index) => (
                <div className="circle-cmp app__flex" key={`circle-${index}`}>
                    <img src={circle} alt="profile_bg" />
                </div>
            ))}
        </motion.div>

        <a target="_blank" href='https://wa.me/2348103312533?text=Hello I have gone through your website and I am interested in your work, and I would like you to ...'>
            <div className="sticky__icon">
                <img src={images.whatsapp} alt="" />
            </div>
        </a>
    </div>
);

export default AppWrap(Header, 'home')
